// Contact info section scaffold (address/phone/email details).
import { useLanguage } from "../../../i18n/LanguageContext";

export default function ContactInfo() {
  const { t } = useLanguage();
  return (
    <aside className="contact-card contact-info-card">
      <h2 className="section-title">{t.contact.infoTitle}</h2>
      <p className="section-desc">{t.contact.infoSubtitle}</p>

      <div className="info-item">{t.footer.email}</div>

      <h2 className="section-title follow-title">{t.contact.followTitle}</h2>

      <div className="socials">
        <a
          href="https://www.instagram.com/khubzzh?igsh=Ymk0aDIxOHQ3eWJw"
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram"
        >
          <i className="bi bi-instagram"></i>
        </a>

        <a
          href="https://www.tiktok.com/@khubzzh?_r=1&_t=ZS-94zPf8ETgqO"
          target="_blank"
          rel="noreferrer"
          aria-label="TikTok"
        >
          <i className="bi bi-tiktok"></i>
        </a>
      </div>
    </aside>
  );
}

